// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_header":"header_mypage_subsc_header__GzTBA","mypage_subsc_title":"header_mypage_subsc_title__2a1Nw","mypage_subsc_config":"header_mypage_subsc_config__xYHXy"};